import type { S25Icons } from "../../../../../modules/s25-icon/s25.icon.const";

/**
 * Dashboard list row `itemTypeId` values from legacy `S25DitemType` (s25-ditem-type.js).
 * Not panel `typeId` or `Item.Ids` — some numbers overlap by convention only.
 */
export const DashDitemTypeId = {
    Event: 1,
    TaskRow: 10,
    FavoriteEvent: 11,
    FavoriteLocation: 14,
    FavoriteResource: 16,
    FavoriteEventSearch: 101,
    FavoriteLocationSearch: 104,
    FavoriteResourceSearch: 106,
    FavoriteReport: 1000,
    EventRequestorSummary: 10001,
    EventSchedulerSummary: 10002,
    EventInstructorSummary: 10003,
    EventAdditionalRoleSummary: 10004,
    DraftSchedulerSummary: 10051,
    DraftRequestorSummary: 10052,
    TaskSummary: 1010,
    TasksOnAgenda: 10101,
    OutstandingTask: 10102,
    FlaggedTask: 10103,
    TasksYouAssigned: 10104,
} as const;

export type DashDitemTypeIdValue = (typeof DashDitemTypeId)[keyof typeof DashDitemTypeId];

/** Mirrors `S25DitemType.main.core.iconStyle` for dash-supported rows. */
export const DASH_DITEM_ROW_ICON_TYPE: Partial<Record<number, S25Icons.Name>> = {
    [DashDitemTypeId.Event]: "event",
    [DashDitemTypeId.FavoriteEvent]: "event",
    [DashDitemTypeId.FavoriteEventSearch]: "event",
    [DashDitemTypeId.EventRequestorSummary]: "event",
    [DashDitemTypeId.EventSchedulerSummary]: "event",
    [DashDitemTypeId.EventInstructorSummary]: "event",
    [DashDitemTypeId.EventAdditionalRoleSummary]: "event",
    [DashDitemTypeId.FavoriteLocation]: "location",
    [DashDitemTypeId.FavoriteLocationSearch]: "location",
    [DashDitemTypeId.FavoriteResource]: "resource",
    [DashDitemTypeId.FavoriteResourceSearch]: "resource",
    [DashDitemTypeId.DraftSchedulerSummary]: "drafts",
    [DashDitemTypeId.DraftRequestorSummary]: "drafts",
    [DashDitemTypeId.TaskSummary]: "task",
    [DashDitemTypeId.TasksOnAgenda]: "task",
    [DashDitemTypeId.TasksYouAssigned]: "task",
    [DashDitemTypeId.OutstandingTask]: "taskDefault",
    [DashDitemTypeId.FlaggedTask]: "flag",
};

/** Mirrors `S25DitemType.main.favorite.isActive`. */
export const DASH_DITEM_FAVORITE_TYPE_IDS: ReadonlySet<number> = new Set([
    DashDitemTypeId.FavoriteEvent,
    DashDitemTypeId.FavoriteEventSearch,
    DashDitemTypeId.FavoriteLocation,
    DashDitemTypeId.FavoriteLocationSearch,
    DashDitemTypeId.FavoriteResource,
    DashDitemTypeId.FavoriteResourceSearch,
    DashDitemTypeId.FavoriteReport,
]);

/** Mirrors `S25DitemType.main.edit.isActive`. */
export const DASH_DITEM_EDIT_TYPE_IDS: ReadonlySet<number> = new Set([
    DashDitemTypeId.FavoriteEvent,
    DashDitemTypeId.FavoriteLocation,
    DashDitemTypeId.FavoriteResource,
]);

/** Dash rows whose `S25Const.itemType` maps to a real object — eligible for `<s25-item>` popover/context menu. */
export const DASH_LIST_S25_ITEM_TYPE_NAMES: ReadonlySet<string> = new Set(["event", "space", "resource"]);

export function dashDitemRowIconType(ditemTypeId: number | undefined): S25Icons.Name | undefined {
    if (ditemTypeId === undefined) {
        return undefined;
    }
    return DASH_DITEM_ROW_ICON_TYPE[ditemTypeId];
}
